import { render, staticRenderFns } from "./CopyAndPay.vue?vue&type=template&id=44077c45&scoped=true&"
import script from "./CopyAndPay.vue?vue&type=script&lang=js&"
export * from "./CopyAndPay.vue?vue&type=script&lang=js&"
import style0 from "./CopyAndPay.vue?vue&type=style&index=0&id=44077c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44077c45",
  null
  
)

export default component.exports